import { Box, HStack, Text } from '@chakra-ui/react'
import { useThemeColors } from '@/hooks/useThemeColors'

type Props = {
  title: string
  children: React.ReactNode
  rightAction?: React.ReactNode
}

export default function OverviewSectionCard({ title, children, rightAction }: Props) {
  const colors = useThemeColors()

  return (
    <Box
      px={3.5}
      py={3}
      bg={colors.cardBg}
      borderWidth="1px"
      borderColor={colors.border}
      borderRadius="md"
    >
      <HStack justify="space-between" align="center" mb={3} gap={2}>
        <Text fontSize="sm" fontWeight="500" color={colors.text} lineHeight="short">
          {title}
        </Text>
        {rightAction ?? null}
      </HStack>
      {children}
    </Box>
  )
}
